export enum RelationsViewModesEnum {
    CARD,
    MAP
}
